import { authManager } from '../auth-manager.js';
import { escapeHTML } from '../security.js';
import { openQRModal } from './qr-modal.js';

export function openNotificationsModal(syncManager) {
  closeNotificationsModal();

  const modalOverlay = document.createElement('div');
  modalOverlay.id = 'notifications-modal-overlay';
  modalOverlay.className = 'qr-modal-overlay';

  modalOverlay.innerHTML = `
    <div class="notifications-modal-card glass-panel" style="max-width: 480px; width: 100%; max-height: 85dvh; display: flex; flex-direction: column; padding: 1.5rem; background: var(--bg-surface); border-radius: 1.5rem; border: 1px solid var(--border-color); box-shadow: 0 24px 48px rgba(0,0,0,0.16); text-align: left; position: relative;">
      <div class="notifications-modal-header" style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.75rem; text-align: left;">
        <div class="notifications-header-title" style="display: flex; align-items: center; gap: 0.75rem;">
          <div class="notifications-bell-icon" style="width: 40px; height: 40px; border-radius: 0.85rem; background: var(--color-primary-bg); color: var(--color-primary); display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
            <span class="material-symbols-outlined" style="font-size: 22px;">notifications</span>
          </div>
          <div>
            <h2 style="font-size: 1.15rem; font-weight: 800; color: var(--text-main); margin: 0; line-height: 1.2;">Notificações da Família</h2>
            <p style="font-size: 0.78rem; color: var(--text-muted); margin: 0.15rem 0 0 0;">Atividades recentes dos membros da sua família</p>
          </div>
        </div>
        <button id="notifications-modal-close" class="qr-modal-close-btn" aria-label="Fechar" style="position: absolute; top: 1rem; right: 1rem; background: transparent; border: none; color: var(--text-subtle); cursor: pointer; display: flex; align-items: center; padding: 0.25rem;">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <div class="notifications-actions-bar" style="display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; padding: 0.5rem 0 0.85rem 0; border-bottom: 1px solid var(--border-color); margin-bottom: 0.75rem;">
        <button id="btn-mark-all-read" class="notifications-sub-btn" title="Marcar todas como lidas">
          <span class="material-symbols-outlined">done_all</span>
          Marcar como lidas
        </button>
        <button id="btn-open-qr-from-notif" class="notifications-sub-btn" title="Acesso Mobile QR Code">
          <span class="material-symbols-outlined">qr_code_2</span>
          Acesso QR
        </button>
      </div>

      <div id="notifications-list-container" class="notifications-list-wrapper" style="flex: 1; overflow-y: auto; max-height: 52vh; text-align: left;">
        <div class="notifications-loading" style="text-align: center; padding: 2.5rem 1rem; color: var(--text-muted);">
          <span class="material-symbols-outlined spin" style="font-size: 32px; color: #10B981;">progress_activity</span>
          <p style="margin-top: 0.5rem; font-size: 0.875rem;">Buscando atividades familiares...</p>
        </div>
      </div>
    </div>
  `;

  document.body.appendChild(modalOverlay);

  // Animate in
  requestAnimationFrame(() => {
    modalOverlay.classList.add('active');
  });

  // Bind close buttons & outside click
  modalOverlay.querySelector('#notifications-modal-close')?.addEventListener('click', closeNotificationsModal);
  modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) closeNotificationsModal();
  });

  // Bind QR Code shortcut button
  modalOverlay.querySelector('#btn-open-qr-from-notif')?.addEventListener('click', () => {
    closeNotificationsModal();
    openQRModal();
  });

  // Mark all as read button
  modalOverlay.querySelector('#btn-mark-all-read')?.addEventListener('click', () => {
    localStorage.setItem('nfce_last_seen_notif_time', new Date().toISOString());
    if (syncManager && syncManager.updateNotificationBadge) {
      syncManager.updateNotificationBadge(0);
    }
    loadNotificationsList(modalOverlay.querySelector('#notifications-list-container'), syncManager);
  });

  // Load content
  loadNotificationsList(modalOverlay.querySelector('#notifications-list-container'), syncManager);
}

export function closeNotificationsModal() {
  const existing = document.getElementById('notifications-modal-overlay');
  if (existing) {
    existing.classList.remove('active');
    setTimeout(() => existing.remove(), 200);
  }
}

async function loadNotificationsList(container, syncManager) {
  if (!container) return;

  try {
    const res = await authManager.fetchWithAuth('/api/family/notifications?limit=25');
    if (!res.ok) {
      throw new Error('Falha ao carregar notificações');
    }

    const data = await res.json();
    const notifications = data.notifications || [];
    const lastSeen = localStorage.getItem('nfce_last_seen_notif_time') || '1970-01-01T00:00:00Z';

    if (notifications.length === 0) {
      container.innerHTML = `
        <div class="notifications-empty-state" style="text-align: center; padding: 2.5rem 1rem;">
          <div class="notifications-empty-icon" style="width: 56px; height: 56px; border-radius: 1.25rem; background: var(--bg-surface-alt); color: var(--text-subtle); display: flex; align-items: center; justify-content: center; margin: 0 auto 1rem auto;">
            <span class="material-symbols-outlined" style="font-size: 28px;">notifications_paused</span>
          </div>
          <h3 style="font-size: 1.1rem; font-weight: 800; color: var(--text-main); margin: 0 0 0.35rem 0;">Tudo em dia!</h3>
          <p style="font-size: 0.82rem; color: var(--text-muted); margin: 0;">Nenhuma nova atividade dos membros da sua família no momento.</p>
          <a href="#family" id="btn-goto-family-notif" class="btn btn-secondary" style="margin-top: 1rem; border-radius: var(--radius-pill); font-size: 0.82rem;">
            <span class="material-symbols-outlined" style="font-size: 16px;">group</span>
            Gerenciar Família
          </a>
        </div>
      `;
      container.querySelector('#btn-goto-family-notif')?.addEventListener('click', () => closeNotificationsModal());
      return;
    }

    // Render list
    container.innerHTML = notifications.map(notif => {
      const isUnread = notif.createdAt > lastSeen;
      const relativeTime = formatRelativeTime(notif.createdAt);
      const iconConfig = getNotificationIconConfig(notif.type);

      const notifInitial = escapeHTML((notif.userName || 'F')[0].toUpperCase());
      const avatarContent = notif.userPicture
        ? `<img src="${escapeHTML(notif.userPicture)}" alt="" class="notif-avatar-img" style="width: 100%; height: 100%; border-radius: 50%; object-fit: cover;" referrerpolicy="no-referrer" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';" />
           <span class="notif-avatar-initial" style="display: none; font-size: 0.95rem; font-weight: 800; color: #374151; width: 100%; height: 100%; align-items: center; justify-content: center;">${notifInitial}</span>`
        : `<span class="notif-avatar-initial" style="font-size: 0.95rem; font-weight: 800; color: #374151; display: flex; width: 100%; height: 100%; align-items: center; justify-content: center;">${notifInitial}</span>`;

      return `
        <div class="notification-item ${isUnread ? 'unread' : ''}" style="display: flex; align-items: center; gap: 0.85rem; padding: 0.85rem; border-radius: 1.15rem; background: ${isUnread ? 'rgba(16, 185, 129, 0.08)' : 'var(--bg-surface-alt)'}; border: 1px solid ${isUnread ? 'rgba(16, 185, 129, 0.35)' : 'var(--border-color)'}; margin-bottom: 0.5rem; cursor: pointer; text-align: left;" data-action-url="${escapeHTML(notif.actionURL || '')}" data-time="${escapeHTML(notif.createdAt)}">
          <div class="notif-avatar-wrapper" style="position: relative; width: 42px; height: 42px; border-radius: 50%; flex-shrink: 0; display: flex; align-items: center; justify-content: center; background: #E5E7EB;">
            ${avatarContent}
            <span class="notif-badge-type" style="position: absolute; bottom: -3px; right: -3px; width: 18px; height: 18px; border-radius: 50%; display: flex; align-items: center; justify-content: center; border: 1.5px solid var(--bg-surface); box-shadow: 0 1px 3px rgba(0,0,0,0.1); background: ${iconConfig.bgColor}; color: ${iconConfig.color};">
              <span class="material-symbols-outlined" style="font-size: 11px;">${iconConfig.icon}</span>
            </span>
          </div>
          <div class="notif-content" style="flex: 1; min-width: 0; text-align: left;">
            <div class="notif-title-row" style="display: flex; align-items: center; gap: 0.4rem; margin-bottom: 0.15rem;">
              <span class="notif-title" style="font-size: 0.85rem; font-weight: 800; color: var(--text-main); white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${escapeHTML(notif.title)}</span>
              ${isUnread ? '<span class="notif-dot-pill" style="font-size: 0.62rem; font-weight: 800; background: #10B981; color: #FFFFFF; padding: 0.1rem 0.4rem; border-radius: var(--radius-pill); text-transform: uppercase;">Nova</span>' : ''}
            </div>
            <div class="notif-subtitle" style="font-size: 0.78rem; color: var(--text-muted); line-height: 1.35; margin-bottom: 0.25rem; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">${escapeHTML(notif.subtitle)}</div>
            <div class="notif-meta" style="display: flex; align-items: center; gap: 0.25rem; font-size: 0.72rem; color: var(--text-subtle);">
              <span class="material-symbols-outlined" style="font-size: 13px;">schedule</span>
              <span>${relativeTime}</span>
            </div>
          </div>
          <div class="notif-chevron" style="color: var(--text-subtle); flex-shrink: 0; display: flex; align-items: center;">
            <span class="material-symbols-outlined">chevron_right</span>
          </div>
        </div>
      `;
    }).join('');

    // Click on individual notification
    container.querySelectorAll('.notification-item').forEach(item => {
      item.addEventListener('click', () => {
        const actionUrl = item.getAttribute('data-action-url');
        const notifTime = item.getAttribute('data-time');

        // Mark as seen up to this notif time
        if (notifTime) {
          const currentLast = localStorage.getItem('nfce_last_seen_notif_time') || '';
          if (!currentLast || notifTime > currentLast) {
            localStorage.setItem('nfce_last_seen_notif_time', notifTime);
          }
        }

        closeNotificationsModal();

        if (actionUrl) {
          if (window.location.hash === actionUrl) {
            window.dispatchEvent(new Event('hashchange'));
          } else {
            window.location.hash = actionUrl;
          }
        }
      });
    });

  } catch (err) {
    console.error('Failed to load notifications:', err);
    container.innerHTML = `
      <div class="notifications-error">
        <span class="material-symbols-outlined">error</span>
        <p>Não foi possível carregar as notificações.</p>
        <button id="btn-retry-notifs" class="btn btn-secondary" style="font-size: 0.8rem; margin-top: 0.5rem; border-radius: var(--radius-pill);">
          Tentar Novamente
        </button>
      </div>
    `;
    container.querySelector('#btn-retry-notifs')?.addEventListener('click', () => loadNotificationsList(container, syncManager));
  }
}

function getNotificationIconConfig(type) {
  switch (type) {
    case 'message':
      return { icon: 'chat_bubble', color: '#2563EB', bgColor: '#DBEAFE' };
    case 'item_added':
      return { icon: 'add_shopping_cart', color: '#059669', bgColor: '#D1FAE5' };
    case 'item_checked':
      return { icon: 'check_circle', color: '#10B981', bgColor: '#ECFDF5' };
    case 'nota_added':
      return { icon: 'receipt_long', color: '#D97706', bgColor: '#FEF3C7' };
    default:
      return { icon: 'notifications', color: '#4B5563', bgColor: '#F3F4F6' };
  }
}

function formatRelativeTime(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr.replace(' ', 'T'));
  if (isNaN(date.getTime())) return dateStr;

  const now = new Date();
  const diffSec = Math.floor((now - date) / 1000);

  if (diffSec < 60) return 'agora há pouco';
  if (diffSec < 3600) return `há ${Math.floor(diffSec / 60)} min`;
  if (diffSec < 86400) return `há ${Math.floor(diffSec / 3600)}h`;
  if (diffSec < 172800) return 'ontem';
  return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
}
